export const pastelPairs = [
    { bg: "#CBDBF6", contrast: "#0091EA" },
    { bg: "#DFEBDB", contrast: "#00C853" },
    { bg: "#FDE6E8", contrast: "#EA495B" },
    { bg: "#FFF0E3", contrast: "#FBC02D" },
    { bg: "#E8E2F7", contrast: "#6200EA" },
    { bg: "#D3D3D3", contrast: "#304FFE" },

    { bg: "#F9EFE0", contrast: "#F8C681" }, // Climate
    { bg: "#E1F5FE", contrast: "#0091EA" }, // Energy
    { bg: "#E6F7FB", contrast: "#00B0DB" }, // Shading
    { bg: "#E0F2F1", contrast: "#00796B" }, // Access
    { bg: "#FDEBED", contrast: "#EA495B" }, // Alarm
    { bg: "#F2EBF0", contrast: "#793369" }, // Audio
    { bg: "#F0F9EE", contrast: "#69C350" }, // Loxone
    { bg: "#EDE7F6", contrast: "#6200EA" }, // IT
    { bg: "#FCE4EC", contrast: "#C2185B" }, // Conventional electrical system
    { bg: "#E8F5E9", contrast: "#00C853" }, // Offer sent
    { bg: "#E8EAF6", contrast: "#304FFE" }, // Open
    { bg: "#FEEBEE", contrast: "#D32F2F" }, // Closed
    { bg: "#FFFDE7", contrast: "#FBC02D" }, // On hold
    { bg: "#F3E5F5", contrast: "#4A148C" }, // My project
    { bg: "#E0F2F1", contrast: "#004D40" }, // Shared project
    { bg: "#F9FBE7", contrast: "#827717" }, // One-wire schematic
];

export const getContrastColor = (bgColor: string) => {
    const pair = pastelPairs.find(p => p.bg === bgColor);
    return pair ? pair.contrast : '#000';
};